<template>
    <img v-if="fileData" :src="fileData.fields.file.url" :alt="fileData.fields.description" />
</template>

<script>
import { downloadAssetCTF } from '../../../plugins/contentful'
export default {
  name: 'CtfRichTextEmbedAsset',
  props: {
    sysId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      fileData: null
    }
  },
  async created () {
    this.fileData = await downloadAssetCTF(this.sysId)
  }
}
</script>
